module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', [(_vm.isJudge) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("请选择需要签约的用户")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "user"
  }, _vm._l((_vm.userInfoList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.choose(index)
        }
      }
    }, [_c('span', {
      staticClass: "radio",
      class: {
        active: _vm.current == index
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "left"
    }, [_vm._v(_vm._s(item.holderName))]), _vm._v(" "), _c('span', {
      staticClass: "center"
    }, [_vm._v(_vm._s(item.certNo))]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_c('span', {
      class: {
        blue: item.signState == '已签约', red: item.signState == '未签约', green: item.signState == '审核中'
      }
    }, [_vm._v(_vm._s(item.signState))])])])
  }), 0), _vm._v(" "), (_vm.isJudge) ? _c('div', {
    staticClass: "ok-wrap"
  }, [_c('button', {
    staticClass: "btn-ok",
    attrs: {
      "id": "feedback-submit",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.go()
      }
    }
  }, [_vm._v("确认")])]) : _vm._e(), _vm._v(" "), _c('no-record', {
    attrs: {
      "id": "myregister-norecord",
      "condition": _vm.userInfoList,
      "tips": "抱歉，没有签约记录"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53fd3909","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/familyDoctor/FamilyDoctor.vue
// module id = 834
// module chunks = 0